import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=6422f2c7&scoped=true"
import script from "./FAQs.vue?vue&type=script&lang=ts"
export * from "./FAQs.vue?vue&type=script&lang=ts"
import style0 from "./FAQs.vue?vue&type=style&index=0&id=6422f2c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6422f2c7",
  null
  
)

export default component.exports